module.exports = __webpack_public_path__ + "assets/fielseg.122d6607.svg";